import script from "./DeletexIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeletexIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__